import { render, staticRenderFns } from "./listother.vue?vue&type=template&id=0b1af2c2&scoped=true"
import script from "./listother.vue?vue&type=script&lang=js"
export * from "./listother.vue?vue&type=script&lang=js"
import style0 from "./listother.vue?vue&type=style&index=0&id=0b1af2c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1af2c2",
  null
  
)

export default component.exports